import React from 'react'
import { Helmet } from 'react-helmet-async'
import SEO from '../../components/SEO'
import Footer from '../../components/Footer'
import Navbar from '../../components/Navbar'
import ServiceHero from './components/ServiceHero/ServiceHero'
import ServicesTimeline from './components/ServicesTimeline/ServicesTimeline'
import { structuredData } from '../../data/structuredData'


export default function Services() {
  return (
    <>
      <SEO
        title='Our Services'
        description='Explore the range of tech services we offer at RaStegHub.'
        url='/services'
      />
      <Helmet>
        <script type='application/ld+json'>{JSON.stringify(structuredData)}</script>
      </Helmet>
      <div className="services">
        <Navbar />
        <ServiceHero />
        <ServicesTimeline />
        <Footer />
      </div>
    </>
  )
}